import api from './client'
import type { User } from '../types'

export type UpdateMePayload = {
  fullName?: string
  email?: string
  removeAvatar?: boolean
  avatar?: File | null
}

function toProfileFormData(data: UpdateMePayload): FormData {
  const formData = new FormData()
  if (data.fullName !== undefined) formData.set('fullName', data.fullName)
  if (data.email !== undefined) formData.set('email', data.email)
  if (data.removeAvatar) formData.set('removeAvatar', 'true')
  if (data.avatar) formData.set('avatar', data.avatar)
  return formData
}

export const authApi = {
  login: (email: string, password: string) =>
    api.post<{ data: { token: string; user: User } }>('/auth/login', { email, password }),

  logout: () => api.post('/auth/logout'),

  me: () => api.get<{ data: User }>('/auth/me'),

  updateMe: (data: UpdateMePayload) => api.put<{ data: User }>('/auth/me', toProfileFormData(data)),

  changePassword: (currentPassword: string, newPassword: string) =>
    api.put('/auth/me/password', { currentPassword, newPassword }),

  forgotPassword: (email: string) =>
    api.post<{ data: { message: string } }>('/auth/forgot-password', { email }),

  resetPassword: (token: string, password: string) =>
    api.post<{ data: { message: string } }>('/auth/reset-password', { token, password }),
}
